import moment, { Moment } from 'moment-timezone';
import { Registrars } from '../types/RegistrarTypes';

/*
{
  "name" : "MCN-REG",
  "webAddress" : {
    "street" : "Via Mazzini, 12/d",
    "city" : "Carrara",
    "state" : "MS",
    "postalcode" : "54033",
    "country" : "it"
  },
  "voice" : "+39.058571872",
  "email" : "lorenzo.luconi@iit.cnr.it",
  "webUrl" : "http://www.reality.it",
  "emailLang" : "it",
  "voiceCode" : "19245310",
  "publish" : true,
  "status" : "active",
  "statusDate" : "2011-05-02T11:27:24+02:00",
  "created" : "2011-04-06T12:27:40+02:00",
  "lastupdate" : "2018-07-02T05:47:01+02:00",
  "_links" : {
    "self" : {
      "href" : "http://localhost:3000/api/registrars/4665"
    },
    "registrar" : {
      "href" : "http://localhost:3000/api/registrars/4665"
    },
    "emailsRegistrar" : {
      "href" : "http://localhost:3000/api/registrars/4665/emailsRegistrar"
    },
    "contract" : {
      "href" : "http://localhost:3000/api/registrars/4665/contract"
    },
    "rcontacts" : {
      "href" : "http://localhost:3000/api/registrars/4665/rcontacts"
    }
  }
}
 */
export class Registrar {
    private _name: string;
    private _voice: string;
    private _email: string;
    private _webUrl: string;
    private _emailLang: string;
    private _voideCode: string;
    private _publish: boolean;
    private _status: string;
    private _statusDate: Moment;
    private _created: Moment;
    private _lastUpdate: Moment;
    private  _links: Registrars.Links;
    private _webAddress: Registrars.WebAddress;


    constructor() {
        this._name = ''
        this._voice = ''
        this._email = ''
        this._webUrl = ''
        this._emailLang = ''
        this._voideCode = ''
        this._publish = false
        this._status = ''
        this._statusDate = moment()
        this._created = moment()
        this._lastUpdate = moment()
        this._links = {} as Registrars.Links
        this._webAddress = {} as Registrars.WebAddress
    }

    get name(): string {
        return this._name;
    }
    set name(name: string) {
        this._name = name;
    }

    get voice(): string {
        return this._voice;
    }
    set voice(voice: string) {
        this._voice = voice;
    }
    get email(): string {
        return this._email;
    }
    set email(email: string) {
        this._email = email;
    }
    get webUrl(): string {
        return this._webUrl;
    }
    set webUrl(webUrl: string) {
        this._webUrl = webUrl;
    }
    get emailLang(): string {
        return this._emailLang;
    }
    set emailLang(emailLang: string) {
        this._emailLang = emailLang;
    }
    get voiceCode(): string {
        return this._voideCode;
    }
    set voiceCode(voiceCode: string) {
        this._voideCode = voiceCode;
    }
    get publish(): boolean {
        return this._publish;
    }
    set publish(publish: boolean) {
        this._publish = publish;
    }
    get status(): string {
        return this._status;
    }
    set status(status: string) {
        this._status = status;
    }
    get statusDate(): Moment {
        return this._statusDate;
    }
    set statusDate(statusDate: Moment) {
        this._statusDate = statusDate;
    }
    get created(): Moment {
        return this._created;
    }
    set created(created: Moment) {
        this._created = created;
    }
    get lastUpdate(): Moment {
        return this._lastUpdate;
    }
    set lastUpdate(lastUpdate: Moment) {
        this._lastUpdate = lastUpdate;
    }
    set links(links: Registrars.Links) {
        this._links = links;
    }
    get links(): Registrars.Links {
        return this._links;
    }
    set webAddress(webAddress: Registrars.WebAddress) {
        this._webAddress = webAddress;
    }
    get webAddress(): Registrars.WebAddress {
        return this._webAddress;
    }
 }